import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "styles";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui/Table";

import UserRow from "./Rows/UserRow";
export class IntegratorCompanyUserTable extends Component {
  render() {
    if (
      Object.keys(this.props.user).length === 0 &&
      this.props.user.constructor === Object
    ) {
      return (
        <div className="container-fluid text-center">
          <h5>No user found.</h5>
        </div>
      );
    }

    return (
      <div className="row">
        <div className="table-body">
          <Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn style={styles.tableRowBorderedTop}>
                  Email
                </TableHeaderColumn>
                <TableHeaderColumn style={styles.tableRowBorderedTop}>
                  Name, surname
                </TableHeaderColumn>

                <TableHeaderColumn style={styles.tableRowBorderedTop}>
                  Company name
                </TableHeaderColumn>
                <TableHeaderColumn style={styles.tableRowBorderedTop}>
                  Subscription
                </TableHeaderColumn>
                <TableHeaderColumn style={styles.tableRowBorderedTop}>
                  LIST OF API
                </TableHeaderColumn>
                <TableHeaderColumn
                  style={{
                    ...styles.tableRowColumnBigCSS,
                    padding: "0px",
                    borderTop: "1px solid rgb(224, 224, 224)",
                  }}
                >
                  <Table selectable={false}>
                    <TableHeader
                      displaySelectAll={false}
                      adjustForCheckbox={false}
                    >
                      <TableRow>
                        <TableHeaderColumn>
                          <p
                            style={{
                              margin: "10px 0px",
                              textAlign: "center",
                            }}
                          >
                            Limits
                          </p>
                        </TableHeaderColumn>
                      </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                      <TableRow style={{ color: "rgb(158, 158, 158)" }}>
                        <TableRowColumn style={styles.nestedRowColumn}>
                          Today
                        </TableRowColumn>
                        <TableRowColumn
                          style={{
                            ...styles.nestedRowColumn,
                            borderLeft: "1px solid rgb(224, 224, 224)",
                            borderRight: "1px solid rgb(224, 224, 224)",
                          }}
                        >
                          Yesterday
                        </TableRowColumn>
                        <TableRowColumn style={styles.nestedRowColumn}>
                          Month
                        </TableRowColumn>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableHeaderColumn>
                <TableHeaderColumn style={styles.tableRowBorderedTop}>
                  USED API LIMITS
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              <UserRow></UserRow>
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

export default connect(({ companyUser }) => ({
  user: companyUser.data,
}))(IntegratorCompanyUserTable);



// WEBPACK FOOTER //
// ./app/components/Integrators/User/Table.jsx